import React from "react";
import { Heading, Box, Card, Flex, Image, Hide,Show } from "@chakra-ui/react";
import Texts from "../animate/textAnimate";
import Zoom from "react-reveal/Zoom";
import GitHubCalendar from "react-github-calendar";
import Gitsmall from "./gitSmall";

const Github = () => {
  return (
    <div>
      <Box border="1px solid orangered" m="auto" w="80%"></Box>
      <br />
      <Heading textAlign={"center"} color="orangered">
        <u>
          <Texts text="MY   GITHUB   STATUS" />
        </u>
      </Heading>
      <br />
      <Hide below="sm">
      <Heading fontSize={"3xl"}>Git Stats</Heading>
      <br />
      <Zoom>
        <Flex
          h={["10vh", "20vh", "20vh", "40vh"]}
          justifyContent={"space-between"}
          w="80%"
          m="auto"
          className="Git"
        >
          <Card className="child" h="90%" w="64%" m="auto" boxShadow="dark-lg">
            <Image
              src="https://github-readme-stats.vercel.app/api?username=mira713&theme=vue-dark&hide_border=false&include_all_commits=false&count_private=false"
              h="100%"
              w="100%"
            />
          </Card>
          <Card className="child" h="90%" w="33%" m="auto" boxShadow="dark-lg">
            <Image
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=mira713&theme=vue-dark&hide_border=false&include_all_commits=false&count_private=false&layout=compact"
              h="100%"
              w="100%"
            />
          </Card>
        </Flex>
      </Zoom>
      <br />
      <br />
      {/* <Hide below='sm'> */}
      <Heading fontSize={"3xl"}>Git Calender</Heading>
      <br />
      <Zoom>
        <Card
          h={["5vh", "18vh", "14vh", "32vh"]}
          overflow="hidden"
          w="75%"
          m="auto"
          boxShadow={"dark-lg"}
          p={[0.5, 1, 2, 3]}
          background="rgb(217, 235, 252)"
        >
          <GitHubCalendar
            username="mira713"
            blockSize={18}
            blockMargin={6}
            blockRadius={100}
            color="orangered"
          />
        </Card>
      </Zoom>
      </Hide>
      <Show below="sm">
          <Gitsmall/>
      </Show>
    </div>
  );
};

export default Github;
